(function (module) {
    'use strict';

    function AddUserToAccountCtrl($timeout, $scope, $state, User, Store, $stateParams, $rootScope, Account) {
        this.$onInit = () => {
            this.accountId = Number($stateParams.accountId);

            Account
                .findById({ id: this.accountId})
                .$promise
                .then((response) => {
                    this.account = Store.setSingleModelData('accounts', response.id, response);
                });

        };

        this.save = () => {
            User.addUserFromAdmin({ user: this.user, accountId: this.accountId })
                .$promise
                .then((res) => {
                    $rootScope.selectedIndex = 1;
                    $state.go('root.admin.accounts.view', { accountId: res.accountId });
                })
                .catch((error) => {
                    this.api = {
                        message: ''
                    };
                    this.api.message = error.data.error.message;

                });

        };
        this.goBack = () => {
            $state.go('root.admin.accounts.view');
        };
    }

    module
        .config(($stateProvider) => {
            $stateProvider
                .state('root.admin.accounts.view.adduser', {
                    url: '/addUser',
                    data: {
                        pageTitle: 'ADMIN_ACCOUNTS_VIEW.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<add-user-to-account-component/>'

                        }
                    }
                });

        })
        .component('addUserToAccountComponent', {
            templateUrl: '/js/admin/accounts/view-account/add-user-to-account/add-user-to-account.html',
            controller: AddUserToAccountCtrl
        });

})(angular.module('rocket.components'));
